import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    // User list (sidebar)
    userList: [],
    isUserListLoading: false,
    isUserListError: false,
    userListError: "",

    // Selected contact
    selectedContact: null,

    // Messages (chat section)
    messages: [],
    messagesPage: 1,
    messagesPerPage: 1000,
    messagesPages: 1,
    messagesCount: 0,
    isMessagesLoading: false,
    isMessagesSuccess: false,
    isMessagesError: false,
    isNewArrived: false,
    messagesError: "",

    // Send message
    isSending: false,

    // Templates
    templates: [],
    isTemplatesLoading: false,
    isTemplatesError: false,
    templatesError: "",

    // Template Status
    currentTemplateStatus: null,
    isTemplateStatusLoading: false,
};

const whatsappSlice = createSlice({
    name: "whatsapp",
    initialState: initialState,
    reducers: {
        // User List
        setLastMessage: (state, action) => {
            const { phone, lastMessage } = action.payload;
            const userIndex = state.userList.findIndex((user) => user.phone === phone);
            if (userIndex !== -1) {
                state.userList[userIndex].lastMessage = lastMessage;
            }
        },
        getUserList: (state) => {
            state.isUserListLoading = true;
        },
        getUserListSuccess: (state, action) => {
            state.userList = action.payload;
            state.isUserListLoading = false;
            state.isUserListError = false;
            state.userListError = "";
        },
        getUserListFailed: (state, action) => {
            state.userList = [];
            state.isUserListLoading = false;
            state.isUserListError = true;
            state.userListError = action.payload;
        },

        // Selected contact
        setSelectedContact: (state, action) => {
            state.selectedContact = action.payload;
            state.messages = [];
            state.messagesPage = 1;
            state.messagesPages = 1;
            state.messagesCount = 0;
        },

        // Messages
        getUserMessagesFrequent: (state) => {
            state.isMessagesLoading = false;
            state.isMessagesError = false;
        },
        getUserMessagesFrequentSuccess: (state, action) => {
            if (action.payload.rows?.length != state.messages.length) {
                state.isNewArrived = true;
                state.messages = action.payload.rows;
                state.messagesPage = +action.payload.page;
                state.messagesPerPage = +action.payload.perPage;
                state.messagesPages = action.payload.pages;
                state.messagesCount = action.payload.count;
            }
        },
        getUserMessages: (state) => {
            state.isMessagesLoading = true;
            state.isMessagesSuccess = false;
        },
        getUserMessagesSuccess: (state, action) => {
            state.messages = action.payload.rows;
            state.messagesPage = +action.payload.page;
            state.messagesPerPage = +action.payload.perPage;
            state.messagesPages = action.payload.pages;
            state.messagesCount = action.payload.count;
            state.isMessagesSuccess = true;
            state.isMessagesLoading = false;
            state.isMessagesError = false;
            state.messagesError = "";
            if (state.isNewArrived) state.isNewArrived = false;
        },
        getUserMessagesFailed: (state, action) => {
            state.messages = [];
            state.isMessagesLoading = false;
            state.isMessagesError = true;
            state.messagesError = action.payload;
        },

        // Send message
        sendMessage: (state, action) => {
            state.isSending = true;
            state.isMessagesSuccess = false;
            if (action.payload && action.payload.body) {
                state.messages.push({
                    sid: "temp_" + Date.now(),
                    direction: "outbound",
                    body: action.payload.body,
                    status: "read",
                    dateCreated: new Date().toISOString(),
                    mediaCount: 0
                });
            }
        },
        sendMessageSuccess: (state) => {
            state.isSending = false;
            state.isMessagesSuccess = true;
        },
        sendMessageFailed: (state) => {
            state.isSending = false;
            state.isMessagesSuccess = false;
        },

        // Send template message
        sendGenericTemplateMessage: (state, action) => {
            state.isSending = true;
            if (action.payload && action.payload.body) {
                state.messages.push({
                    sid: "temp_" + Date.now(),
                    direction: "outbound",
                    body: action.payload.body,
                    status: "read",
                    dateCreated: new Date().toISOString(),
                    mediaCount: 0
                });
            }
        },
        sendGenericTemplateMessageSuccess: (state) => {
            state.isSending = false;
        },
        sendGenericTemplateMessageFailed: (state) => {
            state.isSending = false;
        },

        // Templates list
        getTemplates: (state) => {
            state.isTemplatesLoading = true;
        },
        getTemplatesSuccess: (state, action) => {
            state.templates = action.payload;
            state.isTemplatesLoading = false;
            state.isTemplatesError = false;
            state.templatesError = "";
        },
        getTemplatesFailed: (state, action) => {
            state.templates = [];
            state.isTemplatesLoading = false;
            state.isTemplatesError = true;
            state.templatesError = action.payload;
        },

        // Template status check
        getTemplateStatus: (state) => {
            state.isTemplateStatusLoading = true;
            state.currentTemplateStatus = null;
        },
        getTemplateStatusSuccess: (state, action) => {
            state.isTemplateStatusLoading = false;
            state.currentTemplateStatus = action.payload; // e.g. "pending", "approved" etc.
        },
        getTemplateStatusFailed: (state) => {
            state.isTemplateStatusLoading = false;
            state.currentTemplateStatus = "error";
        },
        clearTemplateStatus: (state) => {
            state.currentTemplateStatus = null;
            state.isTemplateStatusLoading = false;
        },
    },
});

export const {
    setLastMessage,
    getUserList,
    getUserListSuccess,
    getUserListFailed,

    setSelectedContact,

    getUserMessagesFrequent,
    getUserMessagesFrequentSuccess,
    getUserMessages,
    getUserMessagesSuccess,
    getUserMessagesFailed,

    sendMessage,
    sendMessageSuccess,
    sendMessageFailed,

    sendGenericTemplateMessage,
    sendGenericTemplateMessageSuccess,
    sendGenericTemplateMessageFailed,

    getTemplates,
    getTemplatesSuccess,
    getTemplatesFailed,

    getTemplateStatus,
    getTemplateStatusSuccess,
    getTemplateStatusFailed,
    clearTemplateStatus,
} = whatsappSlice.actions;

export default whatsappSlice.reducer;
